export default __webpack_public_path__ + "static/media/hide.883c517d.svg";